export enum BetSlipErrorCodesEnum {
	BetSlipAlreadySubmitted = 400319,
	BetSlipCashoutLUGASUnavailable = 400452,
	BetSlipCancelLUGASUnavailable = 400453,
	BetSlipCancelOASISUnavailable = 400455,
	BetSlipCashoutOASISUnavailable = 400456,
	WalletActivationGracePeriod = 400295,
	/**
	 * Bet slip cancel and cashout, automatic cashout
	 * */
	BetSlipActionsDisabled = 400210,
}
